import { message, Modal } from 'antd';
import { appAction } from '../store/app';
import CONFIG from '@/config';
import _ from 'lodash';


/**
 * 共有方法集合
 * @author: GaoSir
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    /**
     * 获取分页参数
     * @param param 参数 重构参数对象
     * @returns {}
     */
    getPage(param = {}) {
        return Object.assign({}, CONFIG.page, param);
    },


    /**
     * 分页事件参数
     * @param param 参数 重构参数对象
     * @returns {}
     */
    getOnPage(param = {}) {
        const { page, size } = CONFIG.page;
        const _option = {
            page: (param && param.number) || page, //页码
            size: (param && param.size) || size, //每页记录数
            total: (param && param.totalElements) || 0, //数据总条数
        };
        return _option;
    },


    modal(option = {}, type = 'info') {
        return new Promise((resolve) => {
            Modal[type]({
                title: '提示',
                centered: true,
                closable: true,
                class: 'jq-confirm',
                width: 520,
                ...option,
                onOk() {
                    resolve(true);
                },
                onCancel() {
                    resolve(false);
                },
            });
        });
    },

    /**
     * confirm 确认弹窗方法
     */
    confirm(content, option = {}) {
        _.merge(option, { content: content });
        return this.modal(option, 'confirm');
    },



    /**
     * success 确认弹窗方法
     */
    success(content, option = {}) {
        _.merge(option, { content: content });
        return this.modal(option, 'success');
    },

    /**
     * error 确认弹窗方法
     */
    error(content, option = {}) {
        _.merge(option, { content: content });
        return this.modal(option, 'error');
    },

    /**
     * warning 确认弹窗方法
     */
    warning(content, option = {}) {
        _.merge(option, { content: content });
        return this.modal(option, 'warning');
    },


    //消息提示 实例对象
    _Message: null,

    /**
     * Message 消息提示方法
     */
    message(text, type = 'info') {
        if (this._Message) return;
        this._Message = message[type](text, 1.7, () => { this._Message = null; });
    },

    /**
     * error 错误提示信息
     * */
    err(text) {
        this.message(text, 'error');
    },

    /**
     * success 成功提示信息
     * */
    suc(text) {
        this.message(text, 'success');
    },

    /**
     * warning 警告提示信息
     * */
    warn(text) {
        this.message(text, 'warning');
    },

    // 加载层计数器
    _loading: 0,
    // 是否加载中
    _isLoading: false,
    /**
     * loading 加载层方法
     */
    loading(status){
        if (status) {
            this._loading++;
        } else {
            this._loading--;
        }

        const _isLoading = this._loading > 0 ? true : false;
        if (_isLoading === this._isLoading) return;
        this._isLoading = _isLoading;

        appAction.setLoadingState_seg(_isLoading); //更新状态


    },
    //清空参数为空的值
    clearParamVal(param) {
        let _param = {};
        if (param && typeof param === 'object') {
            Object.keys(param).forEach(key => {
                if (param[key] !== '' && param[key] !== null && param[key] !== undefined && param[key] !== 'undefined') {
                    if (typeof param[key] === 'object') {
                        if (Array.isArray(param[key])) {
                            _param[key] = this.clearArrayEmpty(param[key]);
                        } else {
                            if (!this.isEmpty(param[key])) _param[key] = this.clearParamVal(param[key]);
                        }
                    } else {
                        _param[key] = param[key];
                    }
                }
            });
            return _param;
        } else {
            return param;
        }
    },

    clearSpace(param) {
        let _param = {};
        if (param && typeof param === 'object') {
            Object.keys(param).forEach(key => {
                if (typeof param[key] === 'object') {
                    if (Array.isArray(param[key])) {
                        _param[key] = this.clearArrayEmpty(param[key]);
                    } else {
                        if (!this.isEmpty(param[key])) _param[key] = this.clearSpace(param[key]);
                    }
                } else {
                    _param[key] = (param[key] + "").trim();
                }
            });
            return _param;
        } else {
            return param;
        }
    },

    //清空数组空值
    clearArrayEmpty(arg) {
        let _arg = [];
        if (arg && arg.length > 0) {
            arg.forEach((element) => {
                if (element !== '' && element !== null && element !== undefined) _arg.push(element);
            });
        }

        return _arg;
    },

    /**
     * 判断对象是否是空对象，是返回true， 不是返回false
     */
    isEmpty(object) {
        // eslint-disable-next-line no-empty-pattern
        for (let {} in object) {
            return false;
        }
        return true;
    },

    /**
     * json to params
     *  @param arg 参数 要格式化的数据；
     * @returns string
     */
    jsonToParams(arg) {
        if (JSON.stringify(arg) === "{}") return '';

        let params = Object.keys(arg).map((key) => {
            return encodeURIComponent(key) + "=" + encodeURIComponent(arg[key]);
        }).join("&");

        return params;
    },


    /**
     * searchObj
     * location.search 转为json对象
     *
    */
     searchObj(search){
         if(!search) return null;
        return JSON.parse("{\"".concat(decodeURIComponent(search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"'), "\"}"));

        // let urlSearch = new URLSearchParams(location.search);
        // console.log(urlSearch.getAll("a"));
     },


    /**
     *
     * 滚动到顶部
     *
     * @author: wangZK
     * @date: 2020/7/15
     */
    scrollTop() {
        document.documentElement.scrollTop = 0
    },


    /**
     * replace_xx
     * 替换斜线/
     *
     */
    replace_xx(str) {
        if (!str) return str;
        if (typeof str != 'string') return str;
        return str.replace(/\//g, '');
    }

};
